export enum MAGIC_LINK {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=834465823
     */
    SEND_MAGIC_LINK = 'MAGIC_LINK.SEND_MAGIC_LINK',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=834466067
     */
    SIGN_IN_WITH_EMAIL = 'MAGIC_LINK.SIGN_IN_WITH_EMAIL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=835958051
     */
    LINK_HAS_BEEN_SENT_TO = 'MAGIC_LINK.LINK_HAS_BEEN_SENT_TO',
}
